import React, { useState, useMemo } from "react";
import { Table, Pagination, Image, Button, notification } from "antd";
import { sample } from "lodash";

const imageURLS = {};
const usePagination = (data, pageSize, Fascia, setImage) => {
	const [currentPage, setCurrentPage] = useState(1);

	const startIndex = (currentPage - 1) * pageSize;
	const endIndex = startIndex + pageSize;
	let paginatedData = data.slice(startIndex, endIndex);
	if (Fascia) {
		paginatedData = paginatedData.map(item => {
			if (!imageURLS[item["SA Shop ID"]]) {
				imageURLS[item["SA Shop ID"]] = item["Facia"];
			}
			const imageURL = imageURLS[item["SA Shop ID"]];
			if (!imageURL) item["Facia"] = <span>No Image</span>;
			else {
				item["Facia"] = (
					<Button
						className="link-button"
						key={item["SA Shop ID"]}
						onClick={async () => {
							setImage({ preview: true, src: imageURL });
							// Info("Loading Image...");
							// const question_text = "Fascia/Picture (Portrait Mode)";
							// try {
							// 	const { data } = await Services.fetchResponse(item["SA Shop ID"], [question_text]);
							// 	if (isEmpty(data)) {
							// 		notification.error({
							// 			message: "Error",
							// 			description: "No Image Available for this Shop"
							// 		});
							// 		return;
							// 	}

							// 	if ([BAT_UK, BAT_UK_INDEPENDENT, BAT_ORGANIZED, BAT_GERMANY].includes(tenant)) {
							// 		setImage({ preview: true, src: data });
							// 	} else {
							// 		const answer = data.find(({ text }) => {
							// 			return text === question_text;
							// 		});
							// 		if (answer) {
							// 			const { imageURL } = answer;
							// 			setImage({ preview: true, src: imageURL });
							// 		}
							// 	}
							// } catch (error) {
							// 	Error(error.message || "Error While Loading Image.");
							// }
						}}
					>
						Image
					</Button>
				);
			}

			return item;
		});
	}
	const handlePageChange = page => {
		setCurrentPage(page);
	};

	return {
		paginatedData,
		currentPage,
		handlePageChange
	};
};

const CustomTable = ({ data, Fascia, tenant }) => {
	let [pageSize, setPageSize] = useState(10);
	let [{ preview, src }, setImage] = useState({ preview: false, src: "" });
	const { paginatedData, currentPage, handlePageChange } = usePagination(data, pageSize, Fascia, setImage, tenant);
	const columns = useMemo(() => {
		if (data?.length > 0) {
			if (Array.isArray(data)) {
				const sampleObject = sample(data);

				return Object.keys(sampleObject).map(key => {
					return { title: key, dataIndex: key, key: key };
				});
			}
		} else {
			return [];
		}
	}, [data]);
	return (
		<>
			<div>
				<Table
					className="modat-tbl-header c table-striped-rows"
					dataSource={paginatedData}
					columns={columns}
					pagination={false}
				/>
			</div>

			<div className="pt-2">
				<Pagination
					current={currentPage}
					onChange={handlePageChange}
					onShowSizeChange={(index, size) => {
						setPageSize(size);
					}}
					total={data.length}
					defaultPageSize={10}
				/>
			</div>
			{preview && (
				<Image
					width={200}
					style={{ display: "none" }}
					src={src}
					onError={() => {
						setImage({ preview: false, src: "" });
						notification.error({
							message: "Error",
							description: "Unable to Load Image."
						});
					}}
					preview={{
						visible: preview,
						src: src,
						onVisibleChange: () => {
							setImage({ preview: false, src: "" });
						}
					}}
				/>
			)}
		</>
	);
};

export default CustomTable;
